module.exports = __webpack_public_path__ + "static/ActaDeck-BookItalic-644223cf4b58a4104505f6563357e747.woff2";